import { HttpContextToken } from "@angular/common/http";

export const logHttpContext = new HttpContextToken(()=> undefined)